import logo from './logo.svg';
import './App.css';
import { Calculator } from './Calculator.js'
import { Password } from './Password';

function App() {
  return (
    <div className='main'>
      <h1>Lung Cancer Risk Calculator</h1>

      <Password />
    </div>
  );
}

export default App;
